export const SET_BLOCKS = 'SET_BLOCKS';
export const UPDATE_BLOCK = 'UPDATE_BLOCK';
export const SET_BLOCKDATA = 'SET_BLOCKDATA'; // replace part of block, not the whole thing like SET_BLOCKS
export const SET_SETUPDATA = 'SET_SETUPDATA';
export const UPDATE_SETUPDATA = 'UPDATE_SETUPDATA';
export const SET_USERDATA = 'SET_USERDATA';
export const DELETE_BLOCKS = 'DELETE_BLOCKS';

export const SET_BLOCK_PROGRESS = 'SET_BLOCK_PROGRESS';

export const UPDATE_BLOCK_PROGRESSSETTINGS = 'UPDATE_BLOCK_PROGRESSSETTINGS';
export const UPDATE_BLOCK_SHARINGSETTINGS = 'UPDATE_BLOCK_SHARINGSETTINGS';
export const UPDATE_BLOCK_GROUPWORKSETTINGS = 'UPDATE_BLOCK_GROUPWORKSETTINGS';

export const UPDATE_PORTFOLIO_SETTINGS = 'UPDATE_PORTFOLIO_SETTINGS';

export const MOVE_BLOCK_START = 'MOVE_BLOCK_START';
